// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTabs_root__1pvkX","tab":"ProcedureTabs_tab__3fqUu"};